import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetCountriesCurrentCommand extends IRequestCommand<
  IGetCurrentCountriesResponse,
  ErrorDetails,
  IGetCurrentCountriesCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _replaceDefaultHeader = true;
  override _canAddCustomHeaders = false;
  override _needAuthenticate = false;

  public override setParameters(parameters: IGetCurrentCountriesCommandParameters) {
    this.urlSections.push('multiregion');
    this.urlSections.push('operative');
    this.urlSections.push('countries');
    this.composeUrl();
  }
}

export interface IGetCurrentCountriesCommandParameters extends ICommandParameters {
  terms: string;
}

export interface IGetCurrentCountriesResponse extends ICommandResponse {}
